import { Vue, newVue, initVue } from '@/config/vue'

initVue({
  controller: 'home',
  init({ isSpa }) {
    if (isSpa) return

    const HomeEventReporter = Vue.component('home-event-reporter', () =>
      import(/* webpackChunkName: "home-event-reporter" */ './HomeEventReporter.vue')
    )
    newVue({
      render: h => h(HomeEventReporter),
      mount: '.js-vue-home-event-reporter',
    })
  },
})
